import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Container, Typography, Chip, Grid } from '@mui/material';

function Skills() {
  const { t } = useTranslation();

  const skillCategories = t('skills.categories', { returnObjects: true });

  const getCategoryColor = (index) => {
    const colors = [
      { bg: 'rgba(255, 107, 107, 0.15)', color: '#ff6b6b', border: '#ff6b6b' },
      { bg: 'rgba(78, 205, 196, 0.15)', color: '#4ecdc4', border: '#4ecdc4' },
      { bg: 'rgba(255, 215, 61, 0.15)', color: '#ffd93d', border: '#ffd93d' },
      { bg: 'rgba(158, 108, 249, 0.15)', color: '#9e6cf9', border: '#9e6cf9' },
    ];
    return colors[index % colors.length];
  };

  return (
    <Box
      id="skills"
      sx={{
        py: 10,
        position: 'relative',
        overflowX: 'hidden',
        width: '100%',
      }}
    >
      <Container maxWidth="lg">
        <Typography
          variant="h3"
          sx={{
            fontWeight: 700,
            mb: 2,
            textAlign: 'center',
            color: '#fff',
          }}
        >
          {t('skills.title')}
        </Typography>
        <Typography
          variant="body1"
          sx={{
            textAlign: 'center',
            color: '#a3a3a3',
            mb: 6,
            maxWidth: '700px',
            mx: 'auto',
          }}
        >
          {t('skills.subtitle')}
        </Typography>

        <Grid container spacing={4}>
          {skillCategories.map((category, catIndex) => {
            const colors = getCategoryColor(catIndex);
            return (
              <Grid item xs={12} md={6} key={catIndex}>
                  <Box
                    sx={{
                      p: { xs: 2.5, sm: 3 },
                      backgroundColor: '#0a0a0a',
                      border: '2px solid #1a1a1a',
                      borderRadius: '16px',
                      height: '100%',
                      transition: 'all 0.3s ease',
                      maxWidth: '100%',
                      '&:hover': {
                        borderColor: colors.border,
                        transform: 'translateY(-4px)',
                        boxShadow: `0 8px 24px ${colors.bg}`,
                      },
                    }}
                  >
                  <Typography
                    variant="h5"
                    sx={{
                      fontWeight: 600,
                      mb: { xs: 2, sm: 3 },
                      fontSize: { xs: '1.25rem', sm: '1.5rem' },
                      color: colors.color,
                      display: 'flex',
                      alignItems: 'center',
                      gap: 1,
                    }}
                  >
                    <Box
                      sx={{
                        width: 8,
                        height: 8,
                        borderRadius: '50%',
                        bgcolor: colors.color,
                        boxShadow: `0 0 12px ${colors.color}`,
                      }}
                    />
                    {category.name}
                  </Typography>
                  <Box
                    sx={{
                      display: 'flex',
                      flexWrap: 'wrap',
                      gap: 1.5,
                    }}
                  >
                    {category.skills.map((skill, skillIndex) => (
                      <Chip
                        key={skillIndex}
                        label={skill}
                        sx={{
                          backgroundColor: colors.bg,
                          color: colors.color,
                          borderRadius: '8px',
                          fontWeight: 500,
                          fontSize: { xs: '0.8rem', sm: '0.9rem' },
                          px: { xs: 0.75, sm: 1 },
                          py: { xs: 2, sm: 2.5 },
                          border: `1px solid ${colors.border}40`,
                          transition: 'all 0.2s ease',
                          maxWidth: '100%',
                          '&:hover': {
                            backgroundColor: colors.bg,
                            transform: 'translateY(-2px)',
                            boxShadow: `0 4px 12px ${colors.bg}`,
                            borderColor: colors.border,
                          },
                        }}
                      />
                    ))}
                  </Box>
                </Box>
              </Grid>
            );
          })}
        </Grid>
      </Container>
    </Box>
  );
}

export default Skills;
